import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import './CardComponents.css';

export default function CardComponent(props) {
    const Icon = props.icon;
    return (
      <Card className="card" >
      <CardContent className="card-content">
        {<Icon />}
        <h2 className='card-heading'>{props.cardName}</h2>
        <p>{props.cardContent}</p>
      </CardContent>
      {/* <CardActions className="card-actions">
        <IconButton style={{ color: 'green' }} onClick={props.onClick}>
          <ArrowForwardIcon />
        </IconButton>
      </CardActions> */}
    </Card>
    
    );
  }